import React from "react";
import { Helmet } from "react-helmet-async";

// Real Google Reviews from Cell Station customers
const testimonials = [
  {
    name: "Kirkland A.",
    location: "Willow Grove, PA",
    rating: 5,
    text: "Fixed it for just $40 when the phone store would have said I needed a new phone. Saved me hundreds!",
    date: "Dec 2025",
    service: "Phone Repair",
    verified: true
  },
  {
    name: "Niyah T.",
    location: "Abington, PA",
    rating: 5,
    text: "Sam got my phone, told me what was the issue and got it fixed in less than an hour. Amazing service!",
    date: "Dec 2025",
    service: "Boot Loop Fix",
    verified: true
  },
  {
    name: "Jill C.",
    location: "Hatboro, PA",
    rating: 5,
    text: "Excellent Service by Rohid... fixed it in less than 30 minutes. Highly recommend this place!",
    date: "Jan 2026",
    service: "Screen Repair",
    verified: true
  },
  {
    name: "Richard C.",
    location: "Horsham, PA",
    rating: 5,
    text: "Outlook 365 was not functioning properly on laptop. Repaired quickly and showed me how to do next time. Very helpful!",
    date: "Jan 2026",
    service: "Laptop Repair",
    verified: true
  },
  {
    name: "Kenil R.",
    location: "Jenkintown, PA",
    rating: 5,
    text: "Owner extremely helpful... repair done quickly... perfect quality... very reasonable prices. Will definitely come back!",
    date: "Nov 2025",
    service: "Phone Repair",
    verified: true
  },
  {
    name: "Carlos S.",
    location: "Philadelphia, PA",
    rating: 5,
    text: "Went above and beyond with professional services. They even offer discounts for police, fire & EMS. Great family business!",
    date: "Nov 2025",
    service: "General Service",
    verified: true
  }
];

const StarRating = ({ rating }) => (
  <div className="d-flex text-warning mb-2">
    {[...Array(5)].map((_, i) => (
      <i key={i} className={`fas fa-star ${i < rating ? "" : "text-muted"}`} />
    ))}
  </div>
);

const Testimonials = () => {
  // AggregateRating + Review schema — helps get star snippets in Google search results
  const aggregateRatingJsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://www.icellstation.com/#business",
    name: "Cell Station",
    image: "https://www.icellstation.com/assets/images/logo.jpg",
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.6",
      reviewCount: "163",
      bestRating: "5",
      worstRating: "1",
    },
    review: testimonials.map((t) => ({
      "@type": "Review",
      author: { "@type": "Person", name: t.name },
      reviewRating: {
        "@type": "Rating",
        ratingValue: t.rating.toString(),
        bestRating: "5",
      },
      reviewBody: t.text,
      datePublished: t.date,
    })),
  };

  return (
    <section className="section testimonials-section bg-light py-5">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(aggregateRatingJsonLd)}
        </script>
      </Helmet>
      <div className="container">
        <div className="row justify-content-center mb-4">
          <div className="col-lg-8 text-center">
            <span
              className="badge mb-3"
              style={{
                background: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
                color: "white",
                padding: "8px 20px",
                borderRadius: "50px",
                fontSize: "0.85rem",
                fontWeight: "600"
              }}
            >
              <i className="fas fa-star mr-2" />
              Customer Reviews
            </span>
            <h2 className="text-dark font-weight-bold mb-3">
              What Our Customers Say
            </h2>
            <p className="text-muted">
              Join thousands of satisfied customers who trust Cell Station for their device repairs
            </p>
          </div>
        </div>

        <div className="row">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-lg-4 col-md-6 mb-4">
              <div
                className="card h-100 border-0 shadow-sm testimonial-card"
                style={{
                  borderRadius: "12px",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease"
                }}
              >
                <div className="card-body p-4">
                  <StarRating rating={testimonial.rating} />
                  <p
                    className="text-dark mb-3"
                    style={{
                      fontSize: "0.95rem",
                      lineHeight: "1.6",
                      minHeight: "100px"
                    }}
                  >
                    "{testimonial.text}"
                  </p>
                  <div className="border-top pt-3 mt-auto">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h6 className="mb-1 text-dark font-weight-bold d-flex align-items-center" style={{ gap: "6px" }}>
                          {testimonial.name}
                          {testimonial.verified && (
                            <span
                              title="Verified Google Review"
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "3px",
                                background: "#e8f5e9",
                                color: "#2e7d32",
                                fontSize: "0.65rem",
                                padding: "2px 6px",
                                borderRadius: "10px",
                                fontWeight: 600,
                                letterSpacing: "0.3px"
                              }}
                            >
                              <i className="fas fa-check-circle" style={{ fontSize: "0.7rem" }} />
                              VERIFIED
                            </span>
                          )}
                        </h6>
                        {testimonial.location && (
                          <div style={{ fontSize: "0.75rem", color: "#888", marginBottom: "4px" }}>
                            <i className="fas fa-map-marker-alt" style={{ color: "#F50963", marginRight: "4px" }} />
                            {testimonial.location}
                          </div>
                        )}
                        <span
                          className="badge"
                          style={{
                            background: "rgba(0, 123, 255, 0.1)",
                            color: "#007bff",
                            fontSize: "0.75rem"
                          }}
                        >
                          {testimonial.service}
                        </span>
                      </div>
                      <small className="text-muted">
                        <i className="fab fa-google mr-1" style={{ color: "#4285F4" }} />
                        {testimonial.date}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Stats */}
        <div className="row mt-5">
          <div className="col-12">
            <div
              className="p-4 text-center"
              style={{
                background: "linear-gradient(135deg, #007bff 0%, #0056b3 100%)",
                borderRadius: "12px"
              }}
            >
              <div className="row align-items-center">
                <div className="col-md-3 col-6 mb-3 mb-md-0">
                  <h3 className="text-white font-weight-bold mb-0">4.6/5</h3>
                  <div className="d-flex justify-content-center text-warning my-1">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star-half-alt" />
                  </div>
                  <small className="text-white-50">Google Rating</small>
                </div>
                <div className="col-md-3 col-6 mb-3 mb-md-0">
                  <h3 className="text-white font-weight-bold mb-0">163+</h3>
                  <small className="text-white-50">Google Reviews</small>
                </div>
                <div className="col-md-3 col-6">
                  <h3 className="text-white font-weight-bold mb-0">10K+</h3>
                  <small className="text-white-50">Devices Repaired</small>
                </div>
                <div className="col-md-3 col-6">
                  <h3 className="text-white font-weight-bold mb-0">19+</h3>
                  <small className="text-white-50">Years Experience</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Review CTA */}
        <div className="row mt-4">
          <div className="col-12 text-center">
            <p className="text-muted mb-3">
              Had a great experience? We'd love to hear from you!
            </p>
            <a
              href="https://www.google.com/search?q=cell+station+willow+grove#lrd=0x89c6b1fc42ab6fef:0x7c78b804e3a9c5ec,3"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline-primary px-4"
              style={{ borderRadius: "50px" }}
            >
              <i className="fab fa-google mr-2" />
              Leave a Review on Google
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
